module.exports = __webpack_public_path__ + "static/media/Muli-SemiBold.69c54d83.woff";